import "core-js/modules/es6.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    notes: {
      type: String,
      default: null
    },
    todo: {
      type: Object,
      default: null
    },
    source: {
      type: String,
      default: null
    },
    source_text: {
      type: String,
      default: null
    },
    source_id: {
      type: String,
      default: null
    }
  },
  computed: {
    showSourceText: function showSourceText() {
      // to avoid showing multiple times the same description on the entry
      // we only show the source text if it's not the same as the todo name or the integration_todo_id is different from the source_id on the entry
      return this.source && this.source_text && !(this.me.account.hasFeature('project_management') && this.todo && this.todo.integration_code === this.source && (this.todo.integration_todo_id === this.source_id || this.todo.name === this.source_text));
    }
  }
};